import { apiClient, mapLanguageForBackend } from '@/libs/apiClient';
import { handleExternalError } from '@/libs/utils';

export const verifyUser = handleExternalError(async () => {
  const res = await apiClient.get(`/users`);
  return res;
});

export const updateUser = handleExternalError(async (data: any) => {
  const res = await apiClient.post(`/users`, data);
  return res;
});

export const adminGetUsers = handleExternalError(async () => {
  const res = await apiClient.get(`/admin/users`);
  return res;
});

// Admin update user
export const adminUpdateUser = handleExternalError(async (args: { id: number; role: string }) => {
  const res = await apiClient.put(`/admin/users/${args.id}`, { role: args.role });
  return res;
});

// Admin invite user
export const adminInviteUser = handleExternalError(async (data: { email: string; role: string }) => {
  const res = await apiClient.post(`/admin/users`, data);
  return res;
});

// Remove user from organization
export const adminRemoveUser = handleExternalError(async (id: number) => {
  const res = await apiClient.delete(`/admin/users/${id}`);
  return res;
});

export const forgotPassword = handleExternalError(async (email: string) => {
  // Get current language from localStorage, fallback to 'en'
  const currentLanguage = localStorage.getItem('vite-ui-language') || 'en';
  const mappedLanguage = mapLanguageForBackend(currentLanguage);
  const res = await apiClient.post(`/users/forgot-password`, {
    email,
    language: mappedLanguage,
  });
  return res;
});

export const resetPassword = handleExternalError(async (data: { code: string; password: string }) => {
  // Get current language from localStorage, fallback to 'en'
  const currentLanguage = localStorage.getItem('vite-ui-language') || 'en';
  const mappedLanguage = mapLanguageForBackend(currentLanguage);
  const res = await apiClient.post(`/users/reset-password`, {
    ...data,
    language: mappedLanguage,
  });
  return res;
});

export const changePassword = handleExternalError(async (data: { currentPassword: string; newPassword: string }) => {
  // Get current language from localStorage, fallback to 'en'
  const currentLanguage = localStorage.getItem('vite-ui-language') || 'en';
  const mappedLanguage = mapLanguageForBackend(currentLanguage);

  console.log('Change password request data:', {
    current_password: data.currentPassword,
    new_password: data.newPassword,
    language: mappedLanguage,
  });

  const res = await apiClient.put(`/users/change-password`, {
    current_password: data.currentPassword,
    new_password: data.newPassword,
    language: mappedLanguage,
  });
  return res;
});
